'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminForumController', ['$scope', '$http', '$timeout', 'Auth', 'ForumService',
function($scope, $http, $timeout, Auth, ForumService) {

  /* ── état ─────────────────────────────────────────────────── */
  var rawPosts          = [];
  var allPosts          = [];
  $scope.posts          = [];
  $scope.isLoading      = true;
  $scope.successMsg     = '';
  $scope.errorMsg       = '';
  $scope.searchQuery    = '';
  $scope.filterCategorie = '';
  $scope.categories     = [];
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 12;
  $scope.totalItems     = 0;
  $scope.totalPages     = 1;
  $scope.selectedPost   = null;
  $scope.confirmDelete  = null;
  $scope.stats          = { posts: 0, replies: 0, upvotes: 0 };

  /* ── helpers ──────────────────────────────────────────────── */
  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10) || 12;
    $scope.totalItems = allPosts.length;
    $scope.totalPages = Math.ceil(allPosts.length / size) || 1;
    if ($scope.currentPage > $scope.totalPages) { $scope.currentPage = 1; }
    var start = ($scope.currentPage - 1) * size;
    $scope.posts = allPosts.slice(start, start + size);
  }

  function applyFilters() {
    var q   = ($scope.searchQuery     || '').toLowerCase().trim();
    var cat = ($scope.filterCategorie || '').trim();
    allPosts = rawPosts.filter(function(p) {
      var matchQ   = !q   || (p.titre || p.title || '').toLowerCase().indexOf(q) !== -1
                          || (p.auteur || '').toLowerCase().indexOf(q) !== -1;
      var matchCat = !cat || (p.categorie || '') === cat;
      return matchQ && matchCat;
    });
    $scope.currentPage = 1;
    paginate();
  }

  function computeStats(posts) {
    var replies = 0, votes = 0;
    posts.forEach(function(p) {
      replies += (p.replies || []).length;
      votes   += (p.upvotes || 0);
    });
    $scope.stats = { posts: posts.length, replies: replies, upvotes: votes };
  }

  function extractCategories(posts) {
    var seen = {};
    posts.forEach(function(p) {
      if (p.categorie && !seen[p.categorie]) { seen[p.categorie] = true; }
    });
    $scope.categories = Object.keys(seen).sort();
  }

  /* ── pagination ───────────────────────────────────────────── */
  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) { return; }
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [], n = $scope.totalPages, c = $scope.currentPage;
    var start = Math.max(1, c - 2), end = Math.min(n, c + 2);
    for (var i = start; i <= end; i++) { pages.push(i); }
    return pages;
  };

  $scope.onSearch = function() { applyFilters(); };
  $scope.onFilter = function() { applyFilters(); };

  /* ── chargement ───────────────────────────────────────────── */
  $scope.load = function() {
    $scope.isLoading  = true;
    $scope.selectedPost = null;
    ForumService.getPosts().then(function(posts) {
      rawPosts = posts || [];
      computeStats(rawPosts);
      extractCategories(rawPosts);
      applyFilters();
    }).catch(function() {
      flash('errorMsg', 'Erreur lors du chargement des discussions.');
    }).finally(function() { $scope.isLoading = false; });
  };

  /* ── détail post ──────────────────────────────────────────── */
  $scope.viewPost = function(post) {
    $scope.selectedPost = post;
  };

  $scope.closeDetail = function() {
    $scope.selectedPost = null;
  };

  /* ── suppression post ─────────────────────────────────────── */
  $scope.askDelete = function(item, type, $event) {
    if ($event) { $event.stopPropagation(); }
    $scope.confirmDelete = { item: item, type: type };
  };

  $scope.cancelDelete = function() { $scope.confirmDelete = null; };

  $scope.doDelete = function() {
    if (!$scope.confirmDelete) { return; }
    var target = $scope.confirmDelete;
    $scope.confirmDelete = null;

    if (target.type === 'post') {
      ForumService.deletePost(target.item.id, target.item.auteur)
        .then(function() {
          if ($scope.selectedPost && $scope.selectedPost.id === target.item.id) {
            $scope.selectedPost = null;
          }
          $scope.load();
          flash('successMsg', 'Discussion supprimée.');
        }).catch(function() { flash('errorMsg', 'Impossible de supprimer cette discussion.'); });

    } else if (target.type === 'reply') {
      ForumService.deleteReply(target.item.id, target.item.auteur)
        .then(function() {
          if ($scope.selectedPost) {
            $scope.selectedPost.replies = ($scope.selectedPost.replies || []).filter(function(r) {
              return r.id !== target.item.id;
            });
          }
          rawPosts.forEach(function(p) {
            if (p.replies) {
              p.replies = p.replies.filter(function(r) { return r.id !== target.item.id; });
            }
          });
          computeStats(rawPosts);
          flash('successMsg', 'Réponse supprimée.');
        }).catch(function() { flash('errorMsg', 'Impossible de supprimer cette réponse.'); });
    }
  };

  /* ── utilitaires ──────────────────────────────────────────── */
  $scope.formatDate = function(d) {
    if (!d) { return '—'; }
    var dt = (d instanceof Date) ? d : new Date(d);
    if (isNaN(dt.getTime())) { return '—'; }
    return dt.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  $scope.formatTime = function(d) {
    if (!d) { return ''; }
    var dt = (d instanceof Date) ? d : new Date(d);
    if (isNaN(dt.getTime())) { return ''; }
    return dt.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  /* ── init ─────────────────────────────────────────────────── */
  Auth.identity().then(function(user) {
    $scope.user = user;
    $scope.load();
  });

}]);
